export default __webpack_public_path__ + "static/media/PlaystoreLogo.080186b1.png";